const f = ["#6a71e5", "#48dc6b", "#ffd201", "#ffa500", "#ff4966"], A = [
  "#6a71e5",
  "#75e5f4",
  "#48dc6b",
  "#ffd201",
  "#ffa500",
  "#ff4966"
], _ = [
  "#6a71e5",
  "#70abed",
  "#75e5f4",
  "#48dc6b",
  "#ffd201",
  "#ffa500",
  "#ff4966"
], a = [
  "#6a71e5",
  "#70abed",
  "#75e5f4",
  "#48dc6b",
  "#a4d736",
  "#ffd201",
  "#ffa500",
  "#ff4966"
], d = [
  "#6a71e5",
  "#70abed",
  "#75e5f4",
  "#48dc6b",
  "#a4d736",
  "#ffd201",
  "#ffa500",
  "#ff7733",
  "#ff4966"
], e = [
  "#6a71e5",
  "#70abed",
  "#73c8f1",
  "#75e5f4",
  "#48dc6b",
  "#a4d736",
  "#ffd201",
  "#ffa500",
  "#ff7733",
  "#ff4966"
];
export {
  e as HEAT_MAP_PLATFORM_RAINBOW_10,
  f as HEAT_MAP_PLATFORM_RAINBOW_5,
  A as HEAT_MAP_PLATFORM_RAINBOW_6,
  _ as HEAT_MAP_PLATFORM_RAINBOW_7,
  a as HEAT_MAP_PLATFORM_RAINBOW_8,
  d as HEAT_MAP_PLATFORM_RAINBOW_9
};
//# sourceMappingURL=index.es5678.js.map
